var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportSideMenuIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 18,
  fill: "none",
  viewBox: "0 0 14 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeWidth: 1.5,
  d: "M8.004 1H4.43c-1.617 0-2.425 0-2.927.502S1 2.812 1 4.43V13c0 1.616 0 2.424.502 2.927.502.502 1.31.502 2.927.502H9.57c1.617 0 2.425 0 2.927-.502C13 15.424 13 14.617 13 13V5.996c0-.35 0-.526-.065-.683-.066-.158-.19-.282-.437-.53l-3.282-3.28c-.247-.249-.371-.373-.529-.438C8.53 1 8.355 1 8.004 1Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M4.428 9.57h5.143M4.428 13h3.429"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeWidth: 2,
  d: "M7.857 1v3.429c0 .808 0 1.212.251 1.463.251.25.655.25 1.463.25H13"
})));
export { SvgReportSideMenuIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/report-side-menu-icon.svg";